import { JsLogEvent } from '../../serverGeneratedTypings/jsLogEvent';
import { serializeError } from 'serialize-error';

export async function logErrorToServerside(
    message: string,
    applicationId: string | null | undefined,
    applicantId: string | null | undefined,
    data?: object | Error | unknown,
    backend: Backend = 'O1'
) {
    const requestUrl = `/api/n2/log/error`;

    if (data instanceof DOMException && data.name == 'AbortError') {
        return;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((data as any)?.options?.signal?.aborted) {
        //Do not log error, if this client-side error is a consequence of an aborted request
        //This happens when requests are aborted due to e.g. user navigation
        return;
    }

    const app = getProductFromHtml();
    if (data instanceof Error) {
        data = serializeError(data);
    }

    await postInternal(requestUrl, {
        Message: message,
        App: app,
        ApplicationId: applicationId,
        ApplicantId: applicantId,
        Data: data as JsLogEvent['Data'],
        Backend: backend,
    });
}

export async function logInfoToServerSide(
    message: string,
    applicationId: string | null | undefined,
    applicantId: string | null | undefined,
    backend: Backend = 'O1'
) {
    const requestUrl = `/api/n2/log/info`;
    const app = getProductFromHtml();
    await postInternal(requestUrl, { Message: message, App: app, ApplicationId: applicationId, ApplicantId: applicantId, Backend: backend });
}

async function postInternal(requestUrl: string, evnt: JsLogEvent) {
    try {
        const antiforgeryToken = document.getElementById('root')?.dataset?.antiforgerytoken;
        if (!antiforgeryToken) {
            console.log('unable to find antiforgerytoken, aborting logging', evnt);
            return;
        }

        const spaPath = window?.location?.hash;
        const firstQuestionMark = spaPath.indexOf('?');
        const spaPathToPost = firstQuestionMark > 0 && firstQuestionMark < spaPath.length ? spaPath.substring(0, firstQuestionMark) : spaPath;
        const evntToPost: JsLogEvent = { ...evnt, SpaPath: spaPathToPost };

        await fetch(requestUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-XSRF-TOKEN': antiforgeryToken,
            },
            redirect: 'error',
            body: JSON.stringify(evntToPost),
        });
    } catch (err) {
        // We failed logging on server side, log to console!
        console.error('Error while logging', err);
    }
}
function getProductFromHtml() {
    return document.getElementById('root')?.dataset?.product || 'Unknown';
}
